import { render, staticRenderFns } from "./VehicleType.vue?vue&type=template&id=3bbc6d10&scoped=true&"
import script from "./VehicleType.vue?vue&type=script&lang=js&"
export * from "./VehicleType.vue?vue&type=script&lang=js&"
import style0 from "./VehicleType.vue?vue&type=style&index=0&id=3bbc6d10&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bbc6d10",
  null
  
)

export default component.exports